export default __webpack_public_path__ + "static/media/pte_6.7fd8b20c.png";